module.exports = __webpack_public_path__ + "static/media/xlsx.94f5f46a.png";